/** Drafts may have empty chairs and tables. Finalization requires every eligible participant, not a minimum occupied table size. */
export function seatingProblems(
  tables: readonly { tableNumber: number; seats: readonly { enrollmentId: string; seat: string }[] }[],
  eligible: readonly { enrollmentId: string; name: string }[],
  complete = true,
): string[] {
  const problems: string[] = [];
  const names = new Map(eligible.map(p => [p.enrollmentId, p.name]));
  const seen = new Set<string>();
  const numbers = new Set<number>();
  for (const table of tables) {
    if (!Number.isInteger(table.tableNumber) || table.tableNumber < 1) problems.push('Table numbers must be positive whole numbers.');
    if (numbers.has(table.tableNumber)) problems.push(`Table ${table.tableNumber} is duplicated.`);
    numbers.add(table.tableNumber);
    const chairs = new Set<string>();
    for (const seat of table.seats) {
      if (!['east', 'south', 'west', 'north'].includes(seat.seat)) problems.push(`Table ${table.tableNumber} has an invalid seat.`);
      if (chairs.has(seat.seat)) problems.push(`Table ${table.tableNumber} has two players in ${seat.seat}.`);
      chairs.add(seat.seat);
      if (!names.has(seat.enrollmentId)) problems.push(`Table ${table.tableNumber} includes a player who is not eligible for this session.`);
      if (seen.has(seat.enrollmentId)) problems.push(`${names.get(seat.enrollmentId) ?? 'A player'} is seated more than once.`);
      seen.add(seat.enrollmentId);
    }
    if (table.seats.length > 4) problems.push(`Table ${table.tableNumber} has more than four players.`);
  }
  if (complete) {
    const missing = eligible.filter(p => !seen.has(p.enrollmentId));
    if (missing.length) problems.push(`Players to seat: ${missing.map(p => p.name).join(', ')}.`);
    if (!seen.size) problems.push('Seat at least one eligible player before finalizing.');
  }
  return problems;
}
